module.exports = __webpack_public_path__ + "img/icons8-whatsapp-50.e05b4a08.svg";